module.exports = __webpack_public_path__ + "c8c05bfe0d270cc8c717e7622fe46185.svg";